var React = require('react');

function LibraryMusicInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M38.1147 3.75H15.6147C13.5522 3.75 11.8647 5.4375 11.8647 7.5V30C11.8647 32.0625 13.5522 33.75 15.6147 33.75H38.1147C40.1772 33.75 41.8647 32.0625 41.8647 30V7.5C41.8647 5.4375 40.1772 3.75 38.1147 3.75ZM34.3647 13.125H28.7397V23.4375C28.7397 26.025 26.6397 28.125 24.0522 28.125C21.4647 28.125 19.3647 26.025 19.3647 23.4375C19.3647 20.85 21.4647 18.75 24.0522 18.75C25.121 18.75 26.0772 19.1063 26.8647 19.7063V9.375H34.3647V13.125ZM8.11475 11.25H4.36475V37.5C4.36475 39.5625 6.05225 41.25 8.11475 41.25H34.3647V37.5H8.11475V11.25Z","fill":"#E61313"}));
}

LibraryMusicInline.defaultProps = {"width":"46","height":"45","viewBox":"0 0 46 45","fill":"none"};

module.exports = LibraryMusicInline;

LibraryMusicInline.default = LibraryMusicInline;
